import { PageLayout } from "@/components/layouts/PageLayout";
import SubscriptionIncomplete from "@/pages/UserSubscription/SubscriptionIncomplete/SubscriptionIncomplete";
import type { ResumeCheckoutSearchSchema } from "@/routes/rcheckout";
import { useSearch } from "@tanstack/react-router";

const ResumeCheckout = () => {
    const { uid, error: pageError } = useSearch({
        strict: false,
    }) as ResumeCheckoutSearchSchema;

    return (
        <PageLayout>
            <div className="pt-8 md:pt-0">
                {uid && (
                    <SubscriptionIncomplete uid={uid} hasError={pageError} />
                )}
            </div>
        </PageLayout>
    );
};

export default ResumeCheckout;
